import { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { CustomCheckoutModal } from "../customCheckoutModal";
import { PaymentButton } from "../../paymentButton";
import { usePaymentButtonMethod } from "../../hooks/usePaymentMethod";
import { useElements } from "@stripe/react-stripe-js";
import { Loader } from "@common/loader";
import useIsAndroid from "@hooks/useIsAndroid";
import { Button } from "@common/button";
import { updateDataLayer } from "@utils/updateDataLayer";

export const PaymentOptions = ({
  activePlan,
  onCloseCheckout,
  id,
  showTimer,
  variant,
}) => {
  const isWalky = variant === "walky";
  const elements = useElements();
  const isAndroid = useIsAndroid();
  const [isModalOpen, setModalOpen] = useState(false);

  const { isExpressCheckoutAvailable, idPrefix, isLoading } =
    usePaymentButtonMethod();

  useEffect(() => {
    document.body.style.overflow = isModalOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isModalOpen]);

  const isTrial = localStorage.getItem("isTrial") === "true";

  const openModal = () => {
    updateDataLayer({
      event: "checkout_initiated",
      paymentMethod: "Other",
      currency: activePlan.currency,
      amount: isTrial
        ? +activePlan.trialPriceAmount / 100
        : +activePlan.priceAmount / 100,
      product_name: activePlan.title,
    });

    setModalOpen(true);
  };

  const openModalWithOtherOptions = () => {
    updateDataLayer({
      event: "checkout_initiated",
      paymentMethod: "Other",
      currency: activePlan.currency,
      amount: isTrial
        ? +activePlan.trialPriceAmount / 100
        : +activePlan.priceAmount / 100,
      product_name: activePlan.title,
    });

    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    onCloseCheckout?.();
  };

  if (isLoading) {
    return <Loader isWalky={isWalky} />;
  }

  const shouldUseModalOnly = isAndroid || !isExpressCheckoutAvailable;

  return (
    <div className={styles.paymentOptionsWrapper}>
      {!isModalOpen && (
        <>
          {shouldUseModalOnly ? (
            <Button
              variant={isWalky ? "walky" : undefined}
              className={styles.androidPlanButton}
              onClick={openModal}
            >
              GET MY PLAN
            </Button>
          ) : (
            <>
              <PaymentButton
                id={`paywall_continue_${idPrefix}${id}`}
                isWalky={isWalky}
              />
              <button
                onClick={openModalWithOtherOptions}
                className={`${styles.otherPaymentButton} paywall_with_other_option_${id}`}
              >
                CONTINUE WITH OTHER PAYMENT OPTIONS
              </button>
            </>
          )}
        </>
      )}
      {isModalOpen && (
        <CustomCheckoutModal
          onClose={closeModal}
          activePlan={activePlan}
          showTimer={showTimer}
          isWalky={isWalky}
        />
      )}
    </div>
  );
};
